import { Locale, LocaleType } from "../classes/Locale";

interface Language {
    id: string;
    name: string;
    locale: string;
}

export var languages: Language[] = [
    { id: "english", name: "English", locale: Locale.english },
    { id: "korean", name: "한국어", locale: Locale.korean },
    { id: "japanese", name: "日本語", locale: Locale.japanese },
    { id: "french", name: "Français", locale: Locale.french },
    { id: "french-canadian", name: "Français Canadien", locale: Locale.frenchCanadian },
    { id: "german", name: "Deutsch", locale: Locale.german },
    { id: "spanish", name: "Español", locale: Locale.spanish },
    { id: "italian", name: "Italiano", locale: Locale.italian },
    { id: "thai", name: "ไทย", locale: Locale.thai },
];

export const isLocaleType = (value: string): value is LocaleType =>
    Object.values(Locale).includes(value as LocaleType)
